import routeHandler from './routes';

const moduleType = 'Video';
const moduleId = 'videos';
const api = 'videos';
export default { moduleType, moduleId, api, routeHandler };
